import { useBillingModel } from '@/modules/billing/hooks/useBillingModel';
import TabContractStatuses from '@/modules/contract/components/tabContractStatuses/tabContractStatuses';
import { CONTRACT_STATUS, CONTRACTS_TABS_ID } from '@/modules/contract/entities/enums/contract';
import { ContractFilter } from '@/modules/contract/entities/types/contract';
import ContractTable, { ActionNames, ColumnNames } from '@/modules/contract/views/contractTable/contractTable';
import { useQueryStringState } from '@/shared/hooks/useQueryStringState';
import React, { useEffect, useState } from 'react';

const List: React.FC = () => {
  const [ currentTab, setCurrentTab ] = useState<CONTRACTS_TABS_ID>(CONTRACTS_TABS_ID.ACTIVE);

  const [ filters, setFilters ] = useQueryStringState<ContractFilter>({
    status: CONTRACT_STATUS.ACTIVE,
    pageSize: 50,
  });

  const { isCompanyFeeForService } = useBillingModel();

  const columnNames: ColumnNames[] = isCompanyFeeForService
    ? [ 'logo', 'provider', 'benefit', 'code', 'validFrom', 'validUntil', 'status' ]
    : [ 'logo', 'provider', 'benefit', 'validFrom', 'validUntil', 'status' ];

  const actionNames: ActionNames[] | undefined = isCompanyFeeForService ? [ 'goToDetails' ] : undefined;

  useEffect(() => {
    const currentStatus = {
      [CONTRACTS_TABS_ID.ACTIVE]: CONTRACT_STATUS.ACTIVE,
      [CONTRACTS_TABS_ID.CANCELLED]: CONTRACT_STATUS.CANCELLED,
      [CONTRACTS_TABS_ID.EXPIRED]: CONTRACT_STATUS.EXPIRED,
      [CONTRACTS_TABS_ID.ALL]: undefined,
    }[currentTab];

    setFilters((prevFilters) => {
      return {
        ...prevFilters,
        status: currentStatus,
      };
    });
  }, [ currentTab, setFilters ]);

  return (
    <>
      <TabContractStatuses setCurrentTab={ setCurrentTab } currentTab={ currentTab } />

      <ContractTable
        filters={ filters }
        columns={ columnNames }
        actions={ actionNames }
      />
    </>
  );
};

export default List;
